import React from 'react'
import LandingPageComponent from '../components/landingPage'

function LandingPage() {
  return (
    <div><LandingPageComponent/></div>
  )
}

export default LandingPage